import { useApiClient } from '@m43/core';
import { MergedEventsTabResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { useIntegratedStreams } from '../../common/hooks/use-integrated-streams';

export function useIntegratedEventMergedEventsQuery(props: {
    eventId?: number;
    enabled?: boolean;
}) {
    const { eventId } = props;
    const apiClient = useApiClient();
    const mergedEventsTabViewQuery = useQuery(
        ['GetMergedEventsTabView', eventId] as const,
        ({ queryKey }) => {
            return apiClient
                .request<MergedEventsTabResource.GetMergedEventsTabView>({
                    method: 'GET',
                    url: `merged_events_tab/${queryKey[1]}/`,
                })
                .then((resp) => {
                    return resp.data.data;
                });
        },
        {
            cacheTime: 15 * 60 * 1000,
            enabled: false,
        }
    );

    useIntegratedStreams({
        enabled: props.enabled,
        streamNames: ['nudge'],
        query: mergedEventsTabViewQuery,
        promiseBufferCallback: () => mergedEventsTabViewQuery.refetch(),
        onMessage: (message) => {
            const eventNudgeKeys = ['E', 'EC'];
            for (const key of eventNudgeKeys) {
                const entries = message.payload.map[key];
                if (!entries) continue;
                for (const entry of entries) {
                    if (eventId && entry.id === eventId) {
                        return [eventId];
                    }
                }
            }
            return [];
        },
    });

    return mergedEventsTabViewQuery;
}
